'use strict'; // eslint-disable-line

module.exports = ItemList;

/**
 * @type {jQuery|exports|module.exports|Function}
 */
var jQuery = require('jquery');

/**
 * @type {Item|exports|module.exports|Function}
 */
var Item = require('./item');

/**
 * List of items
 * @constructor
 */
function ItemList(container) {
    this.container = container;

    this.$obj = jQuery('<ul data-test-selector="block-dropDownList"></ul>');

    this.items = [];

    this.init();
}

ItemList.prototype.CLASS_LIST = 'ui-dropdownList';

/**
 * Initialize
 * @returns {ItemList}
 */
ItemList.prototype.init = function () {
    this.$obj.addClass(this.CLASS_LIST);

    return this;
};

/**
 * Compose items objects
 * @returns {jQuery}
 */
ItemList.prototype.render = function () {
    return this.$obj.append(this.items.map(function (item) {
        return item.$obj;
    }));
};

/**
 * Add new item
 * @param {int} index
 * @param {String} title
 * @param {String} value
 * @returns {ItemList}
 */
ItemList.prototype.addItem = function (index, title, value) {
    var self = this;

    this.items[index] = new Item(title, value, function (e) {
        e.preventDefault();

        self.selectItem(index);
    });

    return this;
};

/**
 * Mark item as selected
 * @param {int} index
 * @returns {ItemList}
 */
ItemList.prototype.selectItem = function (index) {
    jQuery.each(this.items, function (key, item) {
        if (item.isSelected()) {
            item.unselect();
        }
    });

    this.items[index].select();

    this.container.$obj.trigger('internal.change.rp.selectDropdown', index);

    return this;
};

/**
 * Empty item list
 * @returns {ItemList}
 */
ItemList.prototype.empty = function () {
    this.items = [];
    this.$obj.empty();

    return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-jquery-select/lib/itemList.js
// module id = 1519
// module chunks = 1